import { Injectable, Inject, InjectionToken } from '@angular/core';
import type EstensaModel from 'estensa-module';

export const ESTENSA_MODULE_BUTTONS_SERVICE = new InjectionToken('estensa.module.buttons.service');

export interface IButtonsServiceNg1 {
    isButtonTypeAuthorized(type: EstensaModel.ButtonsTypes): boolean
}

export class NullButtonsService implements IButtonsServiceNg1 {
    isButtonTypeAuthorized() {
        return true;
    }
}

@Injectable({
    providedIn: 'root',
})
export class ButtonsService {
    constructor(@Inject(ESTENSA_MODULE_BUTTONS_SERVICE) private buttonsService: IButtonsServiceNg1) { }

    isButtonTypeAuthorized(type: EstensaModel.ButtonsTypes) {
        return this.buttonsService.isButtonTypeAuthorized(type);
    }
}
